module.exports = __webpack_public_path__ + "img/OOH销售助手.ebf8a551.jpg";